<template>
    <div class="col-12 mx-auto">
        <div class="btn-toolbar justify-content-between mt-sm-1 mt-md-3 mb-1" role="toolbar">
            <div class="form-inline col-lg-6 col-md-12">
                <span v-if="showConfirmationRejectionsGridSettings">
                    <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                       @click.stop="changeGridSettings"
                       data-toggle="tooltip"
                       :title="settingsTooltipText"></i>
                </span>
            </div>

            <div class="input-group" :class="showConfirmationRejectionsGridSettings ? 'col-lg-6 col-md-12':'col-12'">
                <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters"
                       type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                <button class="btn btn-secondary" @click.stop="massSearch">
                    <i class="fas fa-search"></i>
                    {{ $t('buttons.search.btnText') }}
                </button>
                <button class="btn btn-secondary"
                        @click.stop="clearFilters">
                    <i class="fas fa-times"></i>
                    {{ $t('buttons.clearFilters.btnText') }}
                </button>
            </div>
        </div>

        <div v-if="showConfirmationRejectionsGridSettings">
            <GridUserSettings ref="confirmationRejectionsGridSettingss"
                              :visible="showConfirmationRejectionsGridSettingssForm"
                              :grid="$refs['confirmationRejectionsGrid']"
                              :componentName="componentName">
            </GridUserSettings>
        </div>

        <div>
            <kendo-datasource ref="datasource1"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size='gridOptions.pageable.size'
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="confirmationRejectionsGrid"
                        data-source-ref="datasource1"
                        :pageable="gridOptions.pageable"
                        :navigatable="gridOptions.navigatable"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :column-menu="gridOptions.columnMenu"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :toolbar="toolbar"
                        :excel="gridOptions.excel"
                        :dataBound="dataBound">
                <kendo-grid-column v-if="hasEditRights"
                                   :template="btnsTemplate"
                                   field="btnsColumn"
                                   title=" "
                                   :sortable="false"
                                   :filterable="false"
                                   :width="80"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'fullName'"
                                   :title="$t('confirmationRejection.name')"
                                   :width="350"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'fullNameEn'"
                                   :title="$t('confirmationRejection.name')"
                                   :width="350"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'email'"
                                   :title="$t('confirmationRejection.email')"
                                   :template="(e) => gridTextCellTemplate(e, 'email')"
                                   :width="250"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'user'"
                                   :title="$t('confirmationRejection.username')"
                                   :width="250"
                                   :template="(e) => gridTextCellTemplate(e, 'user')"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'note'"
                                   :title="$t('confirmationRejection.note')"
                                   :width="600"
                                   :template="(e) => gridTextCellTemplate(e, 'note')"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'timeUtc'"
                                   :title="$t('confirmationRejection.time')"
                                   :width="200"
                                   :format="customDateTimeFormat"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'rejectedByAdmin'"
                                   :title="$t('confirmationRejection.rejectedByAdmin')"
                                   :width="150"
                                   :template="rejectedByAdminCellTemplate"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'rankingVersion'"
                                   :title="$t('confirmationRejection.rankingVersion')"
                                   :width="150"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'isRankingActive'"
                                   :title="$t('confirmationRejection.isRankingActive')"
                                   :width="150"
                                   :template="isRankingActiveCellTemplate"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</template>

<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "@/components/grid/GridSettingsWrapper";
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import participantService from '@/services/participant.service';
    import { EventClaims } from "@/models/enums";
    import { mapGetters } from 'vuex';

    export default {
        name: 'confimation-rejections-grid',
        components: {
            GridUserSettings
        },
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            eventId: {
                type: Number,
                default: 0,
            },
            componentName: {
                default: 'ConfirmationRejectionsGrid',
                type: String
            },
        },
        data() {
            return {
                showConfirmationRejectionsGridSettings: false,
                showConfirmationRejectionsGridSettingssForm: false,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
                    timeUtc: { name: 'timeUtc', type: 'date', editable: false, nullable: true, visible: true },
                    user: { name: 'user', type: 'string', editable: false, nullable: true, visible: true },
                    rejectedByAdmin: { name: 'rejectedByAdmin', type: 'boolean', editable: false, nullable: true, visible: true },
                    note: { name: 'note', type: 'string', editable: false, nullable: true, visible: true },
                    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
                    fullNameEn: { name: 'fullNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    rankingVersion: { name: 'rankingVersion', type: 'number', editable: false, nullable: true, visible: true },
                    isRankingActive: { name: 'isRankingActive', type: 'boolean', editable: false, nullable: true, visible: true },
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: 'ConfirmationRejections.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/participant/confirmationRejections',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                }
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.authToken) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.authToken);
                }
            },
            dataBound(e) {
                if (e.sender.options.dataSourceRef == 'datasource1'
                    && this.showSettingsBtn
                    && !this.showConfirmationRejectionsGridSettings) {
                    this.showConfirmationRejectionsGridSettings = true;
                }
            },
            datasorceRequestEnd(e) { },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {

                    const newOptions = { eventId: this.eventId, request: options };
                    return kendo.stringify(newOptions);
                }
            },
            changeGridSettings() {
                this.showConfirmationRejectionsGridSettingssForm = !this.showConfirmationRejectionsGridSettingssForm;
            },
            refresh() {
                const grid = this.$refs.confirmationRejectionsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.confirmationRejectionsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.confirmationRejectionsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            rejectedByAdminCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.rejectedByAdmin ? 'badge-danger' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.rejectedByAdmin ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            isRankingActiveCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.isRankingActive ? 'badge-success' : 'badge-secondary') + '">' + kendo.htmlEncode(dataItem.isRankingActive ? this.$t('yes') : this.$t('no')) + '</span>';

                return templateHtml;
            },
            gridTextCellTemplate(dataItem, fieldName) {
                if (dataItem && fieldName) {
                    return this.$helpers.gridTextCellTemplate(dataItem, fieldName, this.userSettings.showColumnValueFullText);
                }

                return '';
            },
            reload() {
                let grid = this.$refs.confirmationRejectionsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read()
                }
            },
            deleteConfirmationRejection(args) {
                console.log(args);
                kendo
                    .confirm(this.$t('confirmationRejection.confirmationDelete', { name: args.fullName }))
                    .then(
                        function () {
                            participantService.deleteConfirmationRejection(args.id, args.registerEntityId)
                                .then(response => {
                                    this.reload();

                                    this.$vs.notify({
                                        title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                        text: this.$helpers.responseMessage(response),
                                        color: 'success',
                                        time: this.$store.getters.notificationDuration
                                    });
                                })
                                .catch(error => {
                                    this.$vs.notify({
                                        title: this.$t(
                                            'request.response.status.' +
                                            this.$helpers.errorStatusCode(error)
                                        ),
                                        text: this.$helpers.errorText(error),
                                        color: 'danger',
                                        time: this.$store.getters.notificationDuration
                                    });
                                });
                        }.bind(this)
                    );
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        btns: [
                            {
                                name: "deleteConfirmationRejection",
                                text: this.$t('buttons.delete.btnText'),
                                tooltip: this.$t('buttons.delete.btnText'),
                                class: 'btn btn-danger',
                                icon: "fas fa-trash",
                                show: this.hasEditRights,
                                clickHandler: this.deleteConfirmationRejection
                            },
                        ]
                    }
                }
            },
        },
        computed:
        {
            ...mapGetters(['dateTimeFormat', 'isEnVersion', 'eventClaims', 'authToken']),
            customDateTimeFormat() {
                return `{0: ${this.dateTimeFormat}}`;
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
            userSettings() {
                const grid = this.$refs.confirmationRejectionsGrid;
                if (grid) {
                    return grid.kendoWidget().getOptions();
                }

                return null;
            },
            hasEditRights() {
                const claim = this.eventClaims[EventClaims.TempRanking];
                if (!claim) {
                    return false;
                }

                if (claim.create || claim.update) {
                    return true;
                }
                return false;
            },
        }
    }
</script>


<style scoped>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }

    .k-grid td {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
